// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__QbpTE","title":"Header_title__3Bg-0","left":"Header_left__3vxqj","clinicName":"Header_clinicName__O4B3k"};